module.exports = __webpack_public_path__ + "static/ey-4-sq-ea6f7999286ba7cd8425ec71e1a31529.png";